export const SET_ADDRESS = "SET_ADDRESS";
export const TOGGLE_MODAL_LIST_CRC = "TOGGLE_MODAL_LIST_CRC";
